import React from 'react';
import { Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';

export const FeaturesSection = ({
  allowedRules,
  setAllowedRules,
  notAllowedRules,
  setNotAllowedRules,
  addItem,
  updateItem,
  removeItem,
}) => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardContent className="p-6 space-y-6">
        <div>
          <div className="flex items-center justify-between mb-3">
            <Label>✅ Allowed Trading Rules</Label>
            <Button size="sm" variant="outline" onClick={() => addItem(allowedRules, setAllowedRules)}>
              <Plus className="h-3 w-3 mr-1" />
              Add Rule
            </Button>
          </div>
          {allowedRules.map((rule) => (
            <div key={rule.id} className="flex gap-2 mb-2">
              <Input
                placeholder="e.g. News Trading"
                value={rule.value}
                onChange={(e) => updateItem(allowedRules, setAllowedRules, rule.id, e.target.value)}
              />
              <Button
                variant="ghost"
                size="icon"
                onClick={() => removeItem(allowedRules, setAllowedRules, rule.id)}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>

        <Separator />

        <div>
          <div className="flex items-center justify-between mb-3">
            <Label>🚫 Not Allowed Trading Rules</Label>
            <Button size="sm" variant="outline" onClick={() => addItem(notAllowedRules, setNotAllowedRules)}>
              <Plus className="h-3 w-3 mr-1" />
              Add Rule
            </Button>
          </div>
          {notAllowedRules.map((rule) => (
            <div key={rule.id} className="flex gap-2 mb-2">
              <Input
                placeholder="e.g. Martingale Strategy"
                value={rule.value}
                onChange={(e) => updateItem(notAllowedRules, setNotAllowedRules, rule.id, e.target.value)}
              />
              <Button
                variant="ghost"
                size="icon"
                onClick={() => removeItem(notAllowedRules, setNotAllowedRules, rule.id)}
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};